export default {
  en: {
    title: 'Daily speaking goal',
    progress: '{{minutes}} of {{goal}} min',
    streakButton_one: 'Streak: {{count}} day',
    streakButton_other: 'Streak: {{count}} days',
    close: 'Close',
    dayStreak_one: 'Day streak',
    dayStreak_other: 'Day streak',
    startStreak: 'Practice today to start your streak',
    keepStreak: 'Practice today to keep your streak',
    goalMetToday: 'Today’s goal is done — see you tomorrow!',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
  },
  ru: {
    title: 'Цель на день',
    progress: '{{minutes}} из {{goal}} мин',
    streakButton_one: 'Стрик: {{count}} день',
    streakButton_few: 'Стрик: {{count}} дня',
    streakButton_many: 'Стрик: {{count}} дней',
    streakButton_other: 'Стрик: {{count}} дня',
    close: 'Закрыть',
    dayStreak_one: 'День подряд',
    dayStreak_few: 'Дня подряд',
    dayStreak_many: 'Дней подряд',
    dayStreak_other: 'Дня подряд',
    startStreak: 'Позанимайтесь сегодня, чтобы начать серию',
    keepStreak: 'Позанимайтесь сегодня, чтобы не прервать серию',
    goalMetToday: 'Цель на сегодня выполнена — до завтра!',
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
  },
  de: {
    title: 'Tagesziel Sprechen',
    progress: '{{minutes}} von {{goal}} Min.',
    streakButton_one: 'Serie: {{count}} Tag',
    streakButton_other: 'Serie: {{count}} Tage',
    close: 'Schließen',
    dayStreak_one: 'Tag in Folge',
    dayStreak_other: 'Tage in Folge',
    startStreak: 'Übe heute, um deine Serie zu starten',
    keepStreak: 'Übe heute, um deine Serie zu halten',
    goalMetToday: 'Tagesziel erreicht – bis morgen!',
    prevMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
  },
  pt: {
    title: 'Meta diária de fala',
    progress: '{{minutes}} de {{goal}} min',
    streakButton_one: 'Sequência: {{count}} dia',
    streakButton_other: 'Sequência: {{count}} dias',
    close: 'Fechar',
    dayStreak_one: 'Dia seguido',
    dayStreak_other: 'Dias seguidos',
    startStreak: 'Pratique hoje para começar sua sequência',
    keepStreak: 'Pratique hoje para manter sua sequência',
    goalMetToday: 'Meta de hoje cumprida — até amanhã!',
    prevMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
  },
  fr: {
    title: 'Objectif oral du jour',
    progress: '{{minutes}} sur {{goal}} min',
    streakButton_one: 'Série : {{count}} jour',
    streakButton_other: 'Série : {{count}} jours',
    close: 'Fermer',
    dayStreak_one: 'Jour d’affilée',
    dayStreak_other: 'Jours d’affilée',
    startStreak: 'Pratique aujourd’hui pour commencer ta série',
    keepStreak: 'Pratique aujourd’hui pour garder ta série',
    goalMetToday: 'Objectif du jour atteint — à demain !',
    prevMonth: 'Mois précédent',
    nextMonth: 'Mois suivant',
  },
  es: {
    title: 'Meta diaria de habla',
    progress: '{{minutes}} de {{goal}} min',
    streakButton_one: 'Racha: {{count}} día',
    streakButton_other: 'Racha: {{count}} días',
    close: 'Cerrar',
    dayStreak_one: 'Día seguido',
    dayStreak_other: 'Días seguidos',
    startStreak: 'Practica hoy para empezar tu racha',
    keepStreak: 'Practica hoy para mantener tu racha',
    goalMetToday: '¡Meta de hoy cumplida, hasta mañana!',
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
  },
};
